import CodeResend from "./code-resend";

export default CodeResend